// import {
//   insertStr,
//   compareCabin,
//   getPhysicalCabinName,
// } from '@csair/emp-helpers';
import { SAVE_PRODUCT_OBJ } from './actions';

const initialState = {
  productObj: {},
};

export default function productReducer(state = initialState, action) {
  switch (action.type) {
    case SAVE_PRODUCT_OBJ:
      return Object.assign({}, state, { productObj: action.productObj });
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/routes/routes/addProductShop/modules/addProduct.js